module.exports = __webpack_public_path__ + "static/media/Divisor.3587f49c.svg";